import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import moment from "moment";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import { Link, useNavigate } from "react-router-dom";
import PageBar from "../../components/common/PageBar";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import SearchInput from "../../components/common/SearchInput";
import MessageDialog from "../../components/common/MessageDialog";
import i18n from "../../services/i18n";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const SystemCodeManagementPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const menuAuthInfo = useMenuAuthInfo();
  const pageSize = 12;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [codeType, setCodeType] = useState("");
  const [codeDesc, setCodeDesc] = useState("");
  const [sbCodeType, setSbCodeType] = useState([
    { code: "", codeDesc: t("L0112") },
  ]);
  const searchCodeType = useRef("");
  const searchCodeDesc = useRef("");

  const [datas, setDatas] = useState([]);
  const [checkCodes, setCheckCodes] = useState([]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadCodeTypeData();
  }, []);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const loadCodeTypeData = () => {
    api
      .post("/common/codetype", {})
      .then((response) => {
        setSbCodeType([{ code: "", codeDesc: t("L0112") }, ...response.data]);
      })
      .catch(() => {});
  };

  const handleSearch = () => {
    searchCodeType.current = codeType;
    searchCodeDesc.current = codeDesc.trim();

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/syscode/view", {
        type: searchCodeType.current,
        desc: searchCodeDesc.current,
        userLang: i18n.language.toUpperCase(),
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setTotalCount(response.data.totalCount);
        setDatas(response.data.content);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleCodeTypeChange = (e) => {
    setCodeType(e.target.value);
  };

  const handleCodeDescChange = (e) => {
    setCodeDesc(e.target.value);
  };

  const handleCheckValue = (e) => {
    if (e.target.checked) {
      setCheckCodes((checkCodes) => [...checkCodes, e.target.value]);
    } else {
      setCheckCodes((checkCodes) =>
        checkCodes.filter((code) => code !== e.target.value)
      );
    }
  };

  const handleAddCode = () => {
    navigate("/manage/systemcode/edit");
  };

  const handleDeleteCode = () => {
    setIsDialogOpen(true);
  };

  const handleCancel = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    if (!checkCodes) {
      return;
    }

    api
      .post("/manage/syscode/delete", {
        ids: checkCodes,
      })
      .then(() => {
        loadContentData();
        setCheckCodes([]);
      })
      .catch(() => {});

    setIsDialogOpen(false);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0084")]}></BreadCrumbDiv>
      <SearchWrapDiv>
        <InputWrapDiv>
          <CodeSelectBox
            value={codeType}
            codes={sbCodeType}
            onChange={handleCodeTypeChange}
            isCodeVisible={false}
            multiple={false}
          ></CodeSelectBox>
          <SearchInput
            width="170px"
            maxLength={300}
            placeholder={t("L0114")}
            value={codeDesc}
            onChange={handleCodeDescChange}
          ></SearchInput>
          <SearchButton onClick={handleSearch}></SearchButton>
        </InputWrapDiv>
      </SearchWrapDiv>

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton
            value={t("L0321")}
            onClick={handleAddCode}
          ></FunctionButton>
        )}
        {menuAuthInfo.del && (
          <FunctionButton
            className={"bg_gray"}
            value={t("L0091")}
            onClick={handleDeleteCode}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "auto" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>{t("L0130")}</th>
                <th>{t("L0112")}</th>
                <th>{t("L0113")}</th>
                <th style={{ textAlign: "left" }}>{t("L0114")}</th>
                <th>{t("L0115")}</th>
                <th>{t("L0104")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input
                        type="checkbox"
                        name="code-check"
                        id={`code-check-${data["id"]}`}
                        value={data["id"]}
                        onChange={handleCheckValue}
                        checked={checkCodes.includes(data["id"].toString())}
                      />
                      <label htmlFor={`code-check-${data["id"]}`}></label>
                    </td>
                    <td>{data.rowNum}</td>
                    <td>{data.type}</td>
                    <td>{data.code}</td>
                    <td style={{ textAlign: "left" }}>
                      {menuAuthInfo.view ? (
                        <Link
                          to="/manage/systemcode/edit"
                          state={{
                            id: data["id"],
                          }}
                        >
                          {data.desc}
                        </Link>
                      ) : (
                        <span>{data.desc}</span>
                      )}
                    </td>
                    <td>{data.createId}</td>
                    <td>
                      {data.createDT ? moment(data.createDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>

      {isDialogOpen && (
        <MessageDialog title={"L0339"} message={t("L0096")}>
          <FunctionButton
            className="bg_gray"
            value={t("L0005")}
            onClick={handleCancel}
          ></FunctionButton>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default SystemCodeManagementPage;
